function BusinessPortalSkeleton() {
  const cards = Array.from({ length: 3 }, (_, index) => index);

  return (
    <div className="grid gap-4 sm:gap-5" aria-label="Loading businesses">
      <div>
        <div className="h-8 w-44 animate-pulse rounded-full bg-[#ece4dc]" />
        <div className="mt-3 h-4 w-64 max-w-full animate-pulse rounded-full bg-[#f0e8df]" />
        <div className="mt-2 h-3.5 w-80 max-w-full animate-pulse rounded-full bg-[#f3ece5]" />
      </div>

      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {cards.map((item) => (
          <div
            key={item}
            className="relative overflow-hidden rounded-[1.2rem] border border-[#e9e1d9] bg-white shadow-[0_16px_34px_rgba(69,48,33,0.08)] sm:rounded-[1.5rem]"
          >
            <div className="absolute inset-x-0 top-0 h-[5.75rem] bg-[linear-gradient(180deg,#f7f0e8_0%,#f4ece4_62%,rgba(255,255,255,0.78)_88%,#ffffff_100%)] sm:h-[6.25rem]" />
            <div className="relative z-[2] p-2.5 sm:p-3.5">
              <div className="flex items-center justify-between">
                <div className="h-8 w-28 animate-pulse rounded-full bg-white/80" />
                <div className="h-8 w-24 animate-pulse rounded-full bg-white/80" />
              </div>

              <div className="mt-2 flex items-start justify-between gap-3 sm:mt-2.5">
                <div className="flex min-w-0 flex-1 items-center gap-3">
                  <div className="h-10 w-10 shrink-0 animate-pulse rounded-[1rem] bg-[#e8ddd3]" />
                  <div className="min-w-0 flex-1">
                    <div className="h-3 w-20 animate-pulse rounded-full bg-[#dfd3c9]" />
                    <div className="mt-2 h-5 w-32 animate-pulse rounded-full bg-[#d8ccc1]" />
                  </div>
                </div>
                <div className="flex gap-1.5">
                  <div className="h-9 w-9 animate-pulse rounded-[1rem] bg-white/80" />
                  <div className="h-9 w-9 animate-pulse rounded-[1rem] bg-white/80" />
                </div>
              </div>

              <div className="mt-3 flex gap-2 sm:mt-3.5">
                <div className="h-7 w-20 animate-pulse rounded-full bg-[#eaf2ed]" />
                <div className="h-7 w-16 animate-pulse rounded-full bg-[#eaf2ed]" />
              </div>

              <div className="mt-2 rounded-[0.9rem] border border-[#ede5dc] bg-[#fbf8f4] p-2 sm:mt-2.5 sm:rounded-[1rem]">
                <div className="h-3 w-36 animate-pulse rounded-full bg-[#ddd1c8]" />
                <div className="mt-3 h-4 w-full animate-pulse rounded-full bg-[#e8ded5]" />
                <div className="mt-2 h-4 w-3/4 animate-pulse rounded-full bg-[#eee6de]" />
              </div>

              <div className="mt-2 grid grid-cols-2 gap-1.5 sm:mt-2.5 sm:gap-2">
                <div className="h-11 animate-pulse rounded-[0.9rem] border border-[#e9ded4] bg-white" />
                <div className="h-11 animate-pulse rounded-[0.9rem] bg-[#d7c9bd]" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BusinessPortalSkeleton;
